<script setup name="login">
import { onMounted, ref } from 'vue';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import { useRouter } from 'vue-router';

const gStore = GlobalStore();
const dStore = DialogStore();
const router = useRouter();
const errorMsg = ref('');

onMounted(() => {
    console.log('onMounted macadamiaLogin page');
    console.log('process.env.VUE_APP_SSO_LOGIN_URL ===', process.env.VUE_APP_SSO_LOGIN_URL);

    const searchURL = new URL(window.location);
    console.log('new URL(window.location) ===', new URL(window.location));
    const accessToken = searchURL?.searchParams.get('accessToken');
    const refreshToken = searchURL?.searchParams.get('refreshToken');

    // 마카다미아 회원권한이 학습회원인 경우 status === '200'
    const loginStatus = searchURL?.searchParams.get('status');
    console.log('loginStatus ===', loginStatus);

    if (accessToken !== 'null' && accessToken !== '' && accessToken !== null) gStore.setToken(accessToken);
    if (refreshToken !== 'null' && refreshToken !== '' && refreshToken !== null) gStore.setReToken(refreshToken);
    gStore.setLoginRoot('macadamia');
    gStore.setIsUserFirstLogin(false);
    gStore.setIsUserPwReset(false);
    gStore.setIsUserPwExpired(false);

    if (gStore.token !== null && gStore.token !== 'null' && loginStatus === '200') {
        gStore.getUserInfo();
        router.push('/learninghome');
    } else {
        if (loginStatus !== null && loginStatus !== '200') {
            if (loginStatus === 'G405') {
                errorMsg.value = `마카다미아 장애 또는 가입이력이 없습니다. 잠시후 다시 시도해 주시기 바랍니다.`;
            } else if (loginStatus === 'G406') {
                errorMsg.value = `학습회원 인증이 필요한 서비스입니다. 마카다미아 로그인 후 학습회원으로 인증을 완료해 주세요.`;
            } else if (loginStatus === 'G407') {
                errorMsg.value = `입회회원은 정회원 전환이 필요합니다. 선생님께 문의해주세요.`;
            } else if (loginStatus === 'G400') {
                errorMsg.value = `써밋 수능국어트레이닝 미입회 회원입니다.`;
            } else if (loginStatus === '900') {
                errorMsg.value = `내부 오류가 발생했습니다. 잠시후 다시 시도해 주시기 바랍니다.`;
            } else {
                errorMsg.value = `서비스에 장애가 발생하였습니다. 잠시후 다시 시도해주시기 바랍니다.`;
            }

            dStore.openMsg(errorMsg.value, () => {
                window.location.href = process.env.VUE_APP_SSO_LOGOUT_URL;
            });
        } else {
            window.location.href = process.env.VUE_APP_SSO_LOGIN_URL;
        }
    }
});
</script>
